import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Registrar Quill Better Table globalmente
import Quill from 'quill';
import QuillBetterTable from 'quill-better-table';

Quill.register({ 'modules/better-table': QuillBetterTable }, true);

if ( environment.production )
{
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
